import { render, staticRenderFns } from "./UpcomingRelease.vue?vue&type=template&id=6e836a8d&scoped=true&"
import script from "./UpcomingRelease.vue?vue&type=script&lang=js&"
export * from "./UpcomingRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e836a8d",
  null
  
)

export default component.exports